import React from "react";
import { Switch, Route } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import Finance from "../pages/finance";
import InvoiceEditRouter from "../pages/finance/Form/InvoiceEditRouter";
import GeneralForm from "../pages/finance/Form/GeneralForm";
// import FinanceOut from "../pages/finance/Form1/DetailJasa.js"; // REMOVED - Form1 folder deleted
import PaymentReceived from "../pages/finance/payment-received";
import PaymentReceivedForm from "../pages/finance/payment-received/Form.js";

const FinanceRouter = () => {
  return (
    <TransitionGroup>
      <CSSTransition classNames="fadein" timeout={300}>
        <Switch>
          {/* Browse utama */}
          <Route exact path="/finance/sales" component={Finance} />
          <Route exact path="/finance" component={Finance} />

          {/* Tambah Invoice Baru (General) */}
          <Route exact path="/finance/add" component={GeneralForm} />

          {/* Edit invoice - routed based on type */}
          <Route exact path="/finance/edit/:id" component={InvoiceEditRouter} />

          {/* Tambah atau edit versi OUT (BC 2.8) - REMOVED */}
          {/* <Route exact path="/finance/out/:id?" component={FinanceOut} /> */}
          {/* <Route exact path="/finance/edit/pabean/:id" component={FinanceOut} /> */}

          {/* Payment Received */}
          <Route exact path="/finance/payment-received" component={PaymentReceived} />
          <Route exact path="/finance/payment-received/form/:id?" component={PaymentReceivedForm} />
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default FinanceRouter;
